var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.component)?_c(_vm.component,{tag:"component",attrs:{"fill1":_vm.fill1,"fill2":_vm.fill2,"fill3":_vm.fill3,"stroke1":_vm.stroke1,"width":_vm.width,"top":_vm.top,"left":_vm.left}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }